export class FadeInMedia {
    constructor() {
        this.init();
    }

    private init(): void {
        const images = document.querySelectorAll<HTMLElement>('.fade-in-media');

        const addAnimationClass = (img: HTMLElement) => {
            if (!img.classList.contains("animate")) {
                img.classList.add("animate");
            }
        };

        // Parallax effect
        const handleParallax = () => {
            images.forEach((img) => {
                const rect = img.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const scrollProgress = 1 - rect.top / windowHeight; // closer to 1 as it enters view
                const zoom = 1 + scrollProgress * 0.05; // scale up to ~1.2
                img.style.transform = `scale(${zoom})`;
                img.style.transformOrigin = "center center";
            });
        };

        window.addEventListener("scroll", handleParallax, { passive: true });

        // Intersection Observer for fade-in
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const img = entry.target as HTMLElement;
                        addAnimationClass(img);
                        obs.unobserve(img);
                    }
                });
            },
            {
                root: null,
                threshold: 0.1,
            }
        );

        images.forEach((img) => observer.observe(img));
    }
}